import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, XCircle } from 'lucide-react';
export function ForWhom() {
  const notIs = ['No es un curso teórico de 20 horas sobre qué es la inteligencia artificial', 'No es contenido desactualizado copiado de YouTube', 'No te pide que pagues suscripciones de ninguna IA', 'No te enseña herramientas complicadas que necesitan configuración técnica', 'No tiene relleno ni páginas de presentación vacías'];
  const isFor = ['Para el emprendedor que quiere vender más con menos esfuerzo.', 'Para el profesional independiente que necesita comunicar mejor su valor.', 'Para el dueño de negocio que toma decisiones con intuición y quiere hacerlo con datos.', 'Para el creador de contenido que se bloquea y pierde horas frente a la pantalla.', 'Para cualquier persona que quiere usar IA de verdad y no sabe por dónde empezar.'];
  const notFor = ['No es para quien busca fórmulas mágicas sin esfuerzo.', 'No es para quien quiere hacer todo con un clic sin aprender nada.', 'No es para quien cree que la IA reemplaza el criterio y la experiencia humana.'];
  return <section className="py-24 bg-card border-y border-white/5" data-id="element-97">
      <div className="max-w-5xl mx-auto px-4 sm:px-6" data-id="element-98">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12" data-id="element-99">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="space-y-12" data-id="element-100">
            <div data-id="element-101">
              <h3 className="text-2xl font-bold text-white mb-6 flex items-center gap-2" data-id="element-102">
                <XCircle className="text-red-500" data-id="element-103" /> LO QUE ESTE PACK NO ES
              </h3>
              <ul className="space-y-4" data-id="element-104">
                {notIs.map((item, i) => <li key={i} className="flex items-start gap-3 text-gray-400" data-id="element-105">
                    <span className="text-red-500 mt-1" data-id="element-106">✗</span>
                    <span data-id="element-107">{item}</span>
                  </li>)}
              </ul>
            </div>

            <div data-id="element-108">
              <h3 className="text-2xl font-bold text-white mb-6 flex items-center gap-2" data-id="element-109">
                <XCircle className="text-red-500" data-id="element-110" /> PARA QUIÉN NO ES
              </h3>
              <ul className="space-y-4" data-id="element-111">
                {notFor.map((item, i) => <li key={i} className="flex items-start gap-3 text-gray-400" data-id="element-112">
                    <span className="text-red-500 mt-1" data-id="element-113">✗</span>
                    <span data-id="element-114">{item}</span>
                  </li>)}
              </ul>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="glass-card p-8 rounded-2xl border-cyan-500/30 bg-cyan-900/10" data-id="element-115">
            <h3 className="text-2xl font-bold text-white mb-8 flex items-center gap-2" data-id="element-116">
              <CheckCircle2 className="text-green-400" data-id="element-117" /> PARA QUIÉN ES ESTE
              PACK
            </h3>
            <ul className="space-y-6" data-id="element-118">
              {isFor.map((item, i) => <li key={i} className="flex items-start gap-4" data-id="element-119">
                  <div className="bg-green-500/20 p-1 rounded-full shrink-0" data-id="element-120">
                    <CheckCircle2 className="w-5 h-5 text-green-400" data-id="element-121" />
                  </div>
                  <span className="text-gray-200 text-lg leading-relaxed" data-id="element-122">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}